import * as Sentry from '@sentry/browser'

export const globalErrorHandler = (err: Error) => {
  // Suppress harmless ResizeObserver error
  if (err.message?.includes('ResizeObserver loop')) {
    return
  }
  Sentry.captureException(err)
}
